<template>
  <div
    id="reports"
    class="row"
  >
    <div class="col-12">
      <v-col
        v-if="dowloading"
        class="subtitle-1 text-center"
        cols="12"
      > Cargando por favor espere...
      </v-col>
      <v-progress-linear
        indeterminate
        :background-color="backgroundLoadingColor"
        :color="loadingColor"
        height="10"
        v-if="dowloading"
      ></v-progress-linear>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="reset"
        @keydown="form.onKeydown($event)"
      >
        <v-container grid-list-xl>
          <toolbar
            :title="title"
            :loading="form.busy"
            :buttons="buttons"
            @getDocuments="getDocuments"
            @downloadExcel="downloadExcel"
          />
          <v-row
            class="wrap justify-space-around form-body"
          >
            <v-col lg="3" md="6" sm="6" cols="12">
              <v-select
                v-model="form.documentType"
                :items="documentTypes"
                label="Tipo de Documento"
                :rules="[rules.required]"
                required
              />
            </v-col>
            <v-col lg="3" md="6" sm="6" cols="12">
              <v-menu
                v-model="dateMenu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="computedDateFormattedEnd"
                    label="Fecha"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-col cols="12" style="padding: 0 !important;">
                  <v-date-picker
                    :color="themeColor"
                    v-model="form.date"
                    :max="form.dateMax"
                    @input="dateMenu2 = false"
                  />
                </v-col>
                <v-col cols="12" style="padding: 0 !important;">
                  <v-btn
                    block
                    :color="themeColor"
                    dark
                    @click="today"
                  >
                    HOY
                  </v-btn>
                </v-col>
              </v-menu>
            </v-col>
            <v-col lg="3" md="6" sm="6" cols="12">
              <v-combobox
                v-model="status"
                :filter="filter"
                :hide-no-data="!search"
                :items="estatus"
                :search-input.sync="search"
                hide-selected
                label="Códigos de Estatus"
                multiple
                small-chips
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <span class="subheading">Crear</span>
                    <v-chip
                      :color="`${colors[nonce - 1]} lighten-3`"
                      small
                    >
                      {{ search }}
                    </v-chip>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :color="`${item.color} lighten-3`"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.text }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >
                      X
                    </v-icon>
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            <v-col lg="3" md="6" sm="6" cols="12">
              <v-select
                v-model="cat_province_id"
                :items="itemsProvince"
                item-value="code"
                item-text="name"
                label="Estado"
                @onchage="getProvincia()"
              />
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <vuetify-select :states="cat_province_id" />
            </v-col>
            <v-col lg="4" md="6" sm="6" cols="12">
              <v-text-field
                v-model="form.serie"
                label="Serie"
                maxlength="4"
              />
            </v-col>
            <v-col lg="4" md="6" sm="6" cols="12">
              <v-text-field
                v-model="form.document_number"
                label="Número de Documento"
                maxlength="20"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-data-table
        v-if="registries != 0"
        :headers="headers"
        :items="registries"
        :class="`elevation-1 ${navbarColor}`"
      >
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Form from 'vform';
import { mapGetters } from 'vuex';
import { format, parseISO } from 'date-fns';
import Toolbar from '~/components/Toolbar';
import VuetifySelect from '~/components/VuetifySelect';
import 'vuetify/src/styles/main.sass';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('reportDocumentFailed') };
  },
  components: {
    VuetifySelect,
    Toolbar,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      loadingColor: 'theme/loadingColor',
      backgroundLoadingColor: 'theme/backgroundLoadingColor',
      navbarColor: 'theme/navbarColor',
      themeColor: 'theme/themeColor',
    }),
    computedDateFormattedEnd() {
        return this.form.date ? format(parseISO(this.form.date), 'dd-MM-yyyy') : '';
    },
  },
  data: () => ({
    title: 'Reporte de Intentos Fallidos',
    form: new Form({
      rif: '',
      status: null,
      report: null,
      document_number: null,
      serie: null,
      documentType: null,
      busy: false,
      date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateMax: format(parseISO(new Date(new Date().setDate(new Date().getDate() + 3)).toISOString()), 'yyyy-MM-dd'),
      typePortal: 'A',
    }),
    dateMenu2: false,
    itemsProvince: [],
    cat_province_id: '',
    valid: false,
    documentTypes: [
      { value: '01', text: 'Factura' },
      { value: '02', text: 'Nota de Crédito' },
      { value: '03', text: 'Nota de Débito' },
      { value: '04', text: 'Guías de Despacho' },
      { value: '05', text: 'Comprobantes de Retención IVA' },
      { value: '06', text: 'Comprobantes de Retención ISLR' },
    ],
    status: [],
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      format: (v) => /^(?=.*[0-9])/.test(v) || 'El campo solo permite caracteres numericos.',
      rucLength: (v) => (!v || v.length <= 11) || 'El campo debe tener máximo 11 caracteres.',
      rucFormat: (v) => (!v || /^[V,J,E,P,G]{1}[-][0-9]{1,9}[-][0-9]{1} || [V,J,E,P,G]{1}[-][0-9]{1,9}$/.test(v)) || 'Formato inválido.',
    },
    date: '',
    startMenu: false,
    allHeaders: [
      {
        text: 'RIF',
        value: 'RIF',
        align: 'left',
        sortable: true,
      }, {
        text: 'Serie',
        value: 'Serie',
        align: 'left',
        sortable: true,
      }, {
        text: 'Transacción',
        value: 'TransactionId',
        align: 'left',
        sortable: true,
      }, {
        text: 'Número de Documento',
        value: 'DocumentNumber',
        align: 'left',
        sortable: true,
      }, {
        text: 'Fecha Recepción',
        value: 'Timestamp',
        align: 'left',
        sortable: true,
      }, {
        text: 'Estatus',
        value: 'Codes',
        align: 'left',
        sortable: true,
      }, {
        text: 'Observaciones',
        value: 'Comment',
        align: 'left',
        sortable: true,
      },
    ],
    registries: 0,
    colors: ['green', 'purple', 'indigo', 'cyan', 'teal', 'orange'],
    editing: null,
    index: -1,
    estatus: [],
    nonce: 1,
    search: null,
    dowloading: false,
    value: 0,
    show: false,
    buttons: [
      {
        id: 'save',
        icon: 'mdi-file-find',
        name: 'Generar Vista Previa',
        event: 'getDocuments',
        color: 'blue darken-1',
      },
      {
        id: 'cancel',
        icon: 'mdi-download',
        name: 'Descargar Excel',
        event: 'downloadExcel',
        color: 'green',
      },
    ],
  }),
  watch: {
    status(val, prev) {
      if (val.length === prev.length) return;
      this.status = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v,
            color: this.colors[this.nonce - 1],
          };
          this.estatus.push(v);
          this.nonce++;
        }
        return v;
      });
    },
  },
  async mounted() {
    this.form.date = this.getDate();
    await this.getProvincia().then((response) => {
      this.itemsProvince = response.data;
      this.cat_province_id = this.itemsProvince[0].code;
    });
  },
  methods: {
    getDocuments() {
      this.validate();
      if (this.$refs.form.validate()) {
        this.dowloading = true;
        this.form.rif = this.$store.state.taxpayer.rif;
        this.form.status = this.status;
        const filteredFields = [];
        const url = '/api/reportLogs'; // Ruta que nos devuelva todos los datos del reporte
        this.form.post(url).then((response) => {
          if (response.data.registries) {
            this.registries = response.data.registries; // creamos array & guardamos el contenido que nos devuelve el response
            this.headers = this.allHeaders;
            this.headers = this.headers.filter((header) => filteredFields.indexOf(header.text) === -1);
          } else {
            this.registries = [];
            this.headers = [];
          }
          this.dowloading = false;
        })
        .catch(() => {
        });
      }
    },

    downloadExcel() {
      if (!this.registries) {
        this.$store.dispatch('notifications/show', {
          message: 'El archivo Excel NO contiene registros que coincidan con los criterios de búsqueda.',
          type: 'error',
        });
      } else {
        let titulo = '';
          if (this.form.documentType === '01') {
              titulo = 'Factura';
            } else if (this.form.documentType === '02') {
              titulo = 'Nota de Crédito';
            } else if (this.form.documentType === '03') {
              titulo = 'Nota de Débito';
            } else if (this.form.documentType === '04') {
              titulo = 'Guías de Despacho';
            } else if (this.form.documentType === '05') {
              titulo = 'Comprobantes de Retención IVA';
            } else if (this.form.documentType === '06') {
              titulo = 'Comprobantes de Retención ISLR';
            }
        this.dowloading = true;
        const url = '/api/reportLogs/export';
        window.axios({
          method: 'post',
          url,
          responseType: 'arraybuffer',
          data: this.form,
        }).then((response) => {
            this.downloadFile(response, `Reporte de Intentos Fallidos  ${titulo}`);

            setTimeout(() => { this.dowloading = false; }, 1000);
        })
        .catch(() => {
        });
      }
    },

    downloadFile(response, filename) {
      // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
      // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
      // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      const newBlob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename }.xlsx`;
      link.click();
      setTimeout(() => {
        // Para Firefox es necesario retrasar la revocación de ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },

    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.index = index;
      } else {
        this.editing = null;
        this.index = -1;
      }
    },

    filter(item, queryText, itemText) {
      if (item.header) return false;
      const hasValue = (val) => (val != null ? val : '');
      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1;
    },

    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.valid = true;
      }
    },
    getDate() {
        const date = new Date();
        const y = date.getFullYear();
        const m = (date.getMonth() + 1 < 10) ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const d = (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate();
        const fecha = `${y}-${m}-${d}`;
      //  console.log(fecha);
        return fecha;
    },
    getProvincia() {
        const state = this.user.state != null ? this.user.state : 'Todos';
        const url = `/api/provinces/${state}`;
        return window.axios.get(url);
    },
    today() {
      this.form.date = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
      this.dateMenu2 = false;
    },
  },
};
</script>
